// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

export default {
	created() {
		this.store = useStore(this.$pinia);
	},

	methods: {
		getEmbededData(articleData, assetId) {
			let embededModuleObject = {};
			let articleContent = articleData || '';
			let embedImagePath = '';
			let videoThumbnail = '';
			if (articleData) {
				if (articleContent) {
					articleContent = articleContent.replace(/[\t\r\n]/g, '');

					const matchedEmbededTags = articleContent.match(/<embeded_module.*?>(.*?)<\/embeded_module>/gi);
					if (matchedEmbededTags && matchedEmbededTags.length > 0) {
						for (let i = 1; i <= matchedEmbededTags.length; i += 1) {
							// eslint-disable-next-line
							const embededType = matchedEmbededTags[i - 1].match(/(?=[^a-z>]type=\"([^"]+)\")/i)[1];
							/* eslint-disable max-len */
							const suppressModule = this.suppressEmbedModule(matchedEmbededTags[i - 1], this.getPagePackageType());
							const embededId = `art-${assetId}-em-${embededType}-${i}`;
							const obj = {
								[embededId]: {
									id: embededId,
									type: embededType,
									content: matchedEmbededTags[i - 1],
								},
							};
							let isTopAligneVideo = false;
							if (embededType && (embededType.toLowerCase() === 'video') && (matchedEmbededTags[i - 1].match(/\salign="top"/i))) {
								isTopAligneVideo = true;
							}
							let isMidAligneVideo = false;
							if (embededType && (embededType.toLowerCase() === 'video') && (matchedEmbededTags[i - 1].match(/\salign="middle"/i))) {
								isMidAligneVideo = true;
							}

							// If not video and not suppressed on site
							if (obj && !isTopAligneVideo && !suppressModule) {
								embededModuleObject = { ...embededModuleObject, ...obj };
								const divRegex = matchedEmbededTags[i - 1].replace(/<embeded_module.*?>(.*?)<\/embeded_module>/gi, `<div id="${embededId}" class="em-mod-${embededType}" ref="${embededId}"></div>`);
								articleContent = articleContent.replace(matchedEmbededTags[i - 1], divRegex);
							}

							if (embededModuleObject && embededType && (embededType.toLowerCase() === 'image')) {
								// eslint-disable-next-line no-loop-func
								Object.keys(obj).forEach((key) => {
									if (obj[key].type === 'image' && obj[key].id && obj[key].content) {
										const { id } = obj[key];
										const ImageContent = obj[key].content;
										const imagePath = this.getThumnailImage(ImageContent);
										const embImagePosition = this.getEmbAstPosition(ImageContent);
										const imageTitle = this.getEmbImageTitle(ImageContent);
										const imageType = this.getImageDetails(ImageContent);
										embedImagePath = imagePath ? `${this.getImageServerUrl()}${imagePath}?resize=750px:*&output-quality=75` : '';
										const assetDescription = this.getAssetDescription(ImageContent);
										const altTxt = this.getAltText(ImageContent);
										const ImgDiv = `<div id="${id}" class="em-mod-${embededType}" ref="${id}"></div>`;
										const replaceImgString = `<div id="${id}" class="em-mod-${embededType}" ref="${id}">
										<aside data-e2e="ia-image" align="${embImagePosition}" class="ia-module-container ia-image ${imageType} " data-metric-module="ia-img-soc">
											<figure>
												<div class="main">
													<img src="${embedImagePath}" alt="${altTxt}"/>
												</div>
												<figcaption>													
													${imageTitle ? `<div><h3>${imageTitle}</h3></div>` : ''}
													
													<p
														class="module_description"
													>
														${assetDescription}
													</p>
												</figcaption>
											</figure>
										</aside>
										</div>`;
										articleContent = articleContent.replace(ImgDiv, replaceImgString);
									}
								});
							}

							if (embededModuleObject && embededModuleObject[`art-${assetId}-em-video-1`] && embededModuleObject[`art-${assetId}-em-video-1`].content) {
								const videoContent = embededModuleObject[`art-${assetId}-em-video-1`].content;
								if (videoContent.match(/<image_path>(.*?)<\/image_path>/i)) {
									const thumbnailImage = videoContent.match(/<image_path>(.*?)<\/image_path>/i)[1] || '';

									videoThumbnail = thumbnailImage ? `${this.getImageServerUrl()}${thumbnailImage}?resize=750px:*&output-quality=35` : '';
									const firstVideoDiv = `<div id="art-${assetId}-em-video-1" ref="art-${assetId}-em-video-1"></div>`;
									let replaceString = '';
									if (isMidAligneVideo) {
										replaceString = `<div id="art-${assetId}-em-video-1" class="midvideo" ref="art-${assetId}-em-video-1">
										<img
											class="firstEmbedVideoPoster preload-img-container"
											src="${videoThumbnail}"
											fetchpriority="high"
											height="auto"
											width="100%"
										/>
									</div>`;
									} else {
										replaceString = `<div id="art-${assetId}-em-video-1" ref="art-${assetId}-em-video-1">
										<img
											class="firstEmbedVideoPoster preload-img-container"
											src="${videoThumbnail}"
											fetchpriority="high"
											height="auto"
											width="100%"
										/>
									</div>`;
									}
									articleContent = articleContent.replace(firstVideoDiv, replaceString);
								}
							}

							if (embededModuleObject && embededType && (embededType.toLowerCase() === 'bulletedlist')) {
								// eslint-disable-next-line no-loop-func
								Object.keys(obj).forEach((key) => {
									if (obj[key].type === 'bulletedlist' && obj[key].id && obj[key].content) {
										const { id } = obj[key];
										const blContent = obj[key].content;
										const blPosition = this.getEmbAstPosition(blContent);
										const blTitle = this.getModuleTitle(blContent);
										const blDescription = this.getModuleDescription(blContent);
										const blData = this.parseContentBulletedList(blContent);
										const embAstDiv = `<div id="${id}" class="em-mod-${embededType}" ref="${id}"></div>`;
										const replaceEmbModString = `<div id="${id}" class="em-mod-${embededType}" ref="${id}">
										<aside data-e2e="ia-bullet-list" align="${blPosition}" class="ia-module-container ia-bullet-list ${blPosition}">
											<p class="module_title" style="font-weight:bold">
												${blTitle}
											</p>
											<p class="module_description">
												${blDescription}
											</p>
											<ul class="bulletList">
												${blData}
											</ul>
										</aside>
										</div>`;
										articleContent = articleContent.replace(embAstDiv, replaceEmbModString);
									}
								});
							}

							if (embededModuleObject && embededType && (embededType.toLowerCase() === 'sharefact')) {
								// eslint-disable-next-line no-loop-func
								Object.keys(obj).forEach((key) => {
									if (obj[key].type === 'sharefact' && obj[key].id && obj[key].content) {
										const { id } = obj[key];
										const sfContent = obj[key].content;
										const embSfPosition = this.getEmbAstPosition(sfContent);
										const sfTitle = this.getModuleTitle(sfContent);
										const moduleDescription = this.getModuleDescription(sfContent);
										const sfDiv = `<div id="${id}" class="em-mod-${embededType}" ref="${id}"></div>`;
										const replaceSfString = `<div id="${id}" class="em-mod-${embededType}" ref="${id}">
										<aside data-e2e="ia-sharefact" id="ia-sharefact" align="${embSfPosition}" class="ia-module-container ia-shareable-fact  ${embSfPosition}">
											<div class="module_title">
												${sfTitle}
											</div>
											<p class="module_description">
												${moduleDescription}
											</p>
										</aside>
										</div>`;
										articleContent = articleContent.replace(sfDiv, replaceSfString);
									}
								});
							}

							if (embededModuleObject && embededType && (embededType.toLowerCase() === 'pullquote')) {
								// eslint-disable-next-line no-loop-func
								Object.keys(obj).forEach((key) => {
									if (obj[key].type === 'pullquote' && obj[key].id && obj[key].content) {
										const { id } = obj[key];
										const pqContent = obj[key].content;
										const embPqPosition = this.getEmbAstPosition(pqContent);
										const pqTitle = this.getModuleTitle(pqContent);
										const pqModuleDescription = this.getModuleDescription(pqContent);
										const pqDiv = `<div id="${id}" class="em-mod-${embededType}" ref="${id}"></div>`;
										const replacePqString = `<div id="${id}" class="em-mod-${embededType}" ref="${id}">
										<aside data-e2e="ia-pull-quote" id="ia-pull-quote" align="${embPqPosition}" class="ia-module-container ia-pull-quote ${embPqPosition}">
											<blockquote class="pq-wrapper">
												<p class="pq-title">
													${pqTitle}
												</p>
												<small class="pq-description">
													${pqModuleDescription}
												</small>
											</blockquote>
										</aside>
										</div>`;
										articleContent = articleContent.replace(pqDiv, replacePqString);
									}
								});
							}

							// If suppressed, remove the code
							if (suppressModule) {
								articleContent = articleContent.replace(matchedEmbededTags[i - 1], '');
							}
						}
					}
				}
			}
			if (Object.keys(embededModuleObject).length < 1) {
				embededModuleObject = null;
			}
			return {
				embededModuleObject,
				articleContent,
				embedImagePath,
				videoThumbnail,
			};
		},
		/* eslint-disable camelcase */
		suppressEmbedModule(config, s_packageType) {
			let suppressModule = false;
			let suppresFromFED = false;
			let suppresFromSite = false;
			const isFedPage = (s_packageType === 'Editorial Destination');
			const isSitePage = !isFedPage;

			/* eslint-disable no-param-reassign */
			config = config || '';
			if (config) {
				suppresFromFED = this.setSupressShareFlag(config.suppress_from_fed);
				suppresFromSite = this.setSupressShareFlag(config.suppress_from_site);

				if (isFedPage && suppresFromFED) {
					suppressModule = true;
				} else if (isSitePage && suppresFromSite) {
					suppressModule = true;
				}
			}
			return suppressModule;
		},
		setSupressShareFlag(suppressValue) {
			if (suppressValue === true || suppressValue === 'true') {
				return true;
			}
			return false;
		},
		getPagePackageType() {
			/* eslint-disable max-len */
			if (this.store.pagedata && this.store.pagedata.omniture && this.store.pagedata.omniture.s_package_type) {
				return this.store.pagedata.omniture.s_package_type;
			}
			return '';
		},
		getThumnailImage(content) {
			let thumbnailImage = '';
			const thumbnail = content.match(/thumbnail="(.[^"]+)"/gi);

			if (thumbnail && thumbnail[0]) {
				// eslint-disable-next-line
				thumbnailImage = thumbnail[0].replace(/thumbnail=\"/g, '').replace(/"/gi, '');
			}
			return thumbnailImage;
		},

		getImageDetails(content) {
			let width = '';
			let height = '';

			const widthStr = content.match(/width="(.[^"]+)"/gi);
			const heightStr = content.match(/height="(.[^"]+)"/gi);

			if (widthStr && widthStr[0]) {
				// eslint-disable-next-line
				width = widthStr[0].replace(/width=\"/g, '').replace(/"/gi, '');
			}

			if (heightStr && heightStr[0]) {
				// eslint-disable-next-line
				height = heightStr[0].replace(/height=\"/g, '').replace(/"/gi, '');
			}

			return width > height ? 'landscape' : 'portrait';
		},

		getImageServerUrl() {
			return this.store?.pagedata?.omniture?.image_server_url;
		},

		getEmbAstPosition(content) {
			let embAstPosition = '';
			const position = content.match(/align="(.[^"]+)"/gi);

			if (position && position[0]) {
				// eslint-disable-next-line
				embAstPosition = position[0].replace(/align="/g, '').replace(/"/gi, '');
			}
			return embAstPosition;
		},

		getAssetDescription(content) {
			let assetDescription = '';
			const description = content.match(/(?=[^a-z>]asset_description="([^"]+)")/i);

			if (description && description[1]) {
				// eslint-disable-next-line
				assetDescription = description[1];
			}
			return assetDescription;
		},

		isMobileView() {
			let isMobile = false;
			if (typeof window !== 'undefined') {
				// eslint-disable-next-line no-restricted-globals
				if (screen.width < 768) {
					isMobile = true;
				}
			}
			return isMobile;
		},
		getEmbImageTitle(content) {
			let title = '';
			const modTitle = content.match(/(?=[^a-z>]asset_title="([^"]+)")/i);
			if (modTitle && modTitle[1]) {
				// eslint-disable-next-line prefer-destructuring
				title = modTitle[1];
			}
			return title;
		},

		getAltText(content) {
			let altTextData = '';
			const regex = /(?=[^a-z>]alt="([^"]+)")/i;
			const match = content.match(regex);
			if (match && match[1]) {
				// eslint-disable-next-line prefer-destructuring
				altTextData = match[1];
			}
			return altTextData;
		},

		getModuleTitle(content) {
			let bltitle = '';
			const modTitle = content.match(/(?=[^a-z>]module_title="([^"]+)")/i);

			if (modTitle && modTitle[1]) {
				// eslint-disable-next-line prefer-destructuring
				bltitle = modTitle[1];
			}
			return bltitle;
		},

		getModuleDescription(content) {
			let moduleDescription = '';
			const description = content.match(/(?=[^a-z>]module_description="([^"]+)")/i);

			if (description && description[1]) {
				// eslint-disable-next-line
				moduleDescription = description[1];
			}
			return moduleDescription;
		},

		parseContentBulletedList(data) {
			let bulletArr = data;
			let emptyblDesc;
			if (bulletArr.includes('<description></description>')) {
				// eslint-disable-next-line no-param-reassign
				bulletArr = bulletArr.replace(/<description><\/description>/gi, '');
				emptyblDesc = true;
			} else {
				emptyblDesc = false;
			}
			bulletArr = bulletArr.replace(/<embeded_module(.*?)><bulletlist>/gi, '');
			bulletArr = bulletArr.replace(/<\/bulletlist><\/embeded_module>/gi, '');
			bulletArr = bulletArr.replace(/<bulletitem>/gi, '');
			bulletArr = bulletArr.replace(/<\/bulletitem>/gi, '');
			if (emptyblDesc) {
				bulletArr = bulletArr.replace(/<btitle(.*?)>/gi, '<li class="btitle">');
				bulletArr = bulletArr.replace(/<\/btitle>/gi, '</li>');
			} else {
				bulletArr = bulletArr.replace(/<btitle(.*?)>/gi, '<dt class="btitle">');
				bulletArr = bulletArr.replace(/<\/btitle>/gi, '</dt>');
				bulletArr = bulletArr.replace(/<description>/gi, '<dd class="desc-wrapper"><div class= "desc-section"><div class="description">');
				bulletArr = bulletArr.replace(/<\/description>/gi, '</div></div></dd>');
			}
			return bulletArr;
		},

	},
};
